import { FORM_OF_ACCOUNTING_KPIR } from '../../src/constants/crm';

export default {
  index(paginationUrl, config = {}) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/fixed-assets${ paginationUrl }`, { ...config });
  },

  show(id) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/bookkeepings/fixed-assets/' + id);
  },

  update({ fixedAsset, liquidationData }) {
    return axios.put(import.meta.env.VITE_SITE_URL + '/bookkeepings/fixed-assets/' + fixedAsset.id, { fixedasset: fixedAsset, liquidationData });
  },

  store(fixedasset) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/bookkeepings/fixed-assets/', { fixedasset });
  },

  delete(fixedAssetId) {
    return axios.delete(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/fixed-assets/${ fixedAssetId }`);
  },

  prepareForPrint({
                    id,
                    template,
                  }) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/bookkeepings/fixed-assets/prepare-for-print/' + id, {
      template,
    });
  },
  printEvidenceFixedAssets({
                             type,
                             template,
                             date,
                           }) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/bookkeepings/fixed-assets/evidence-fixed-assets-print/', {
      type,
      template,
      date,
    });
  },
  generateInventoryNumber(date = null) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/bookkeepings/fixed-assets/generate-inventory-number', {
      date,
    });
  },
  createEvidence({ period, evidencetype = FORM_OF_ACCOUNTING_KPIR }) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/fixed-assets/evidences`, {
      period,
      evidencetype,
    });
  },
  liquidate({
      liquidationDate,
      lastEntryPeriod,
      ignoreUndepreciatedValue,
      liquidation_comments,
      fixedAssetId,
      reduceHealthContribution,
      saleValue,
      saleDate,
      ignoreInHealthContributionBase
            }) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/fixed-assets/liquidate`, {
      liquidationDate,
      lastEntryPeriod,
      ignoreUndepreciatedValue,
      liquidation_comments,
      fixedAssetId,
      reduceHealthContribution,
      saleValue,
      saleDate,
      ignoreInHealthContributionBase
    });
  },
  liquidateUpdate({
      liquidationDate,
      lastEntryPeriod,
      ignoreUndepreciatedValue,
      liquidation_comments,
      fixedAssetId,
      reduceHealthContribution,
      saleValue,
      saleDate,
      ignoreInHealthContributionBase
            }) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/fixed-assets/liquidate-update`, {
      liquidationDate,
      lastEntryPeriod,
      ignoreUndepreciatedValue,
      liquidation_comments,
      fixedAssetId,
      reduceHealthContribution,
      saleValue,
      saleDate,
      ignoreInHealthContributionBase
    });
  },
};
